import { useMemo, useState } from 'react';

import { useAppSelector } from 'src/store/reducers';
import { getSections, type NavigatorSection } from 'src/util/getSections';

type UseNavigatiorReturn = {
  isNavigatorInitiated: boolean;
  sections: NavigatorSection[];
  setSections: (sections: NavigatorSection[]) => void;
};

export const useNavigator = (lastActivity: number): UseNavigatiorReturn => {
  const [sections, setSections] = useState(() => getSections(document));

  const isNavigatorEnabled = useAppSelector(state => state.refero.ui.isNavigatorEnabled);

  // Recompute sections when lastActivity changes
  const currentSections = useMemo(() => {
    const newSections = getSections(document);
    return newSections;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastActivity]);

  if (currentSections !== sections && currentSections.length !== sections.length) {
    setSections(currentSections);
  }

  const isNavigatorInitiated = !!isNavigatorEnabled && getSections(document).length > 0;

  return { isNavigatorInitiated, sections, setSections };
};
